import ButtonPrimaryEllipse from './ButtonPrimaryEllipse';

export default ButtonPrimaryEllipse;
